import { ROLES } from './roles'

export const RoutesFields = {
  HOME: {
    PATH: '/',
    PERMISSIONS: [],
    TITLE: 'Agendar Entrega',
    MENU: true,
    PARENT: null,
    GRANDPARENT: null,
  },
  REGISTRATION_AGENDA: {
    PATH: '/agendamento/:date',
    PERMISSIONS: [...ROLES.FORNECEDOR, ...ROLES.TRASPORTADORA, ...ROLES.ADMIN],
    TITLE: 'Novo Agendamento',
    MENU: false,
    PARENT: null,
    GRANDPARENT: null,
  },
  REGISTRATION_PRE_AGENDA: {
    PATH: '/agendamento/pre/:date',
    PERMISSIONS: [...ROLES.FORNECEDOR, ...ROLES.TRASPORTADORA, ...ROLES.ADMIN, ...ROLES.PRE_AGENDAMENTO],
    TITLE: 'Pre Agendamento',
    MENU: false,
    PARENT: null,
    GRANDPARENT: null,
  },
  REGISTRATION_PRE_AGENDA_FINALIZE: {
    PATH: '/agendamento/finalize/:agendaId',
    PERMISSIONS: [...ROLES.FORNECEDOR, ...ROLES.TRASPORTADORA, ...ROLES.ADMIN, ...ROLES.PRE_AGENDAMENTO],
    TITLE: 'Finalizar o Agendamento',
    MENU: false,
    PARENT: null,
    GRANDPARENT: null,
  },
  RELATORIO_FORNECEDOR: {
    PATH: '/agendamentos-fornecedor',
    PERMISSIONS: [...ROLES.FORNECEDOR, ...ROLES.ADMIN],
    TITLE: 'Agendamentos Fornecedor',
    MENU: true,
    PARENT: null,
    GRANDPARENT: null,
  },
  RELATORIO_TRASPORTADORA: {
    PATH: '/agendamentos-trasportadora',
    PERMISSIONS: [...ROLES.TRASPORTADORA, ...ROLES.ADMIN],
    TITLE: 'Agendamentos Transportadora',
    MENU: true,
    PARENT: null,
    GRANDPARENT: null,
  },
  FOLLOW_UP: {
    PATH: '/follow-up/cotacoes',
    PERMISSIONS: [...ROLES.FORNECEDOR, ...ROLES.ADMIN],
    TITLE: 'Cotações',
    MENU: true,
    PARENT: null,
    GRANDPARENT: null,
  },
}
